import React, { useContext } from 'react';
import SystemBanner from './SystemBanner';
import { BannerContext } from '../../providers/BannerProvider';
import './BannerHost.css';

/**
 * BannerHost — renders the current banner stack at the top-center of the
 * chat region. Mounts inside ChatRegion (orchestration wires this).
 *
 * If no <BannerProvider> is mounted above us we render nothing rather than
 * throw — keeps the host resilient when used in isolation in tests.
 */
function BannerHost() {
  const ctx = useContext(BannerContext);
  if (!ctx) return null;
  const { banners, dismissBanner } = ctx;
  if (!banners.length) return null;

  return (
    <div
      className="glacier-banner-host"
      data-testid="banner-host"
      // Stack is non-interactive content; live updates are announced by the
      // banner itself (which uses role="status").
      aria-hidden="false"
    >
      {banners.map((b) => (
        <SystemBanner
          key={b.id}
          kind={b.kind}
          text={b.text}
          // Pass 0 — provider already owns the auto-dismiss timer. Setting it
          // here would double-schedule and produce 200ms of visual jitter.
          duration={0}
          onDismiss={() => dismissBanner(b.id)}
        />
      ))}
    </div>
  );
}

export default BannerHost;
